export default "<div>\n\t<h4 class=\"title\">{{title}}</h4>\n\t<h5 class=\"sub-title\">{{subTitle}}</h5>\n</div>"